<!--
 * @Author: LHB
 * @Date: 2022-06-08 22:04:13
 * @LastEditTime: 2022-07-23 09:58:38
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\Changemobile\index.vue
 * ---
-->

<template>
  <div class="wrap">
    <!-- 第一步-start -->
    <div class="content" v-if="step == 1">
      <div class="box-input box-phone">
        <div>
          <p class="login-title">验证当前登录账号的手机号</p>
          <p class="login-sub-title">
            更换手机号，旧手机号将不可登录，下次使用新手机号登录
          </p>
          <div class="moblieWrap">
            <div class="origin-box">
              <img
                class="phone_icon"
                src="../../assets/images/phone_icon@2x.png"
                alt=""
              />
              <div class="origin-mobile">{{ mobile }}</div>
            </div>
            <div class="inputItem">
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="verCode"
                  :maxlength="6"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="code-right">
                <div class="verBtn" @click="isCount ? '' : getCode()">
                  {{ codeText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-button class="loginBtn" @click="nextstep(1)">下一步</van-button>
    </div>
    <!-- 第一步-end -->
    <!-- 第二步-start -->
    <div class="content" v-if="step == 2">
      <div class="box-input box-phone">
        <div>
          <p class="login-title">绑定新号码</p>
          <p class="login-sub-title">
            更换手机号，旧手机号将不可登录，下次使用新手机号登录
          </p>
          <div class="moblieWrap">
            <div class="inputItem">
              <div class="input-left">+86</div>
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="newTel"
                  :maxlength="11"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div class="inputItem">
              <div class="input-right">
                <input
                  class="mobileInput"
                  type="tel"
                  v-model="newVerCode"
                  :maxlength="6"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="code-right">
                <div class="verBtn" @click="isCount ? '' : getCode()">
                  {{ codeText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-button
        class="loginBtn"
        :loading="loginLoading"
        :loading-text="loadingText"
        @click="changeConfirm"
        >确认修改</van-button
      >
    </div>
    <!-- 第二步-end -->
    <!-- 第三步-start -->
    <div class="content" v-if="step == 3">
      <div class="box-input box-phone">
        <div>
          <div class="moblieWrap">
            <div class="origin-box">
              <img
                class="success_icon"
                src="../../assets/images/success.png"
                alt=""
              />
              <div class="success-title">课程手机号已修改成功！</div>
              <div class="success-mobile">
                <span class="newmobile-1">新号码</span>
                <span class="newmobile-2"> +86 {{ newTel }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-button class="loginBtn loginBtn-success" @click="changeSuccess"
        >我知道了</van-button
      >
    </div>
    <!-- 第三步-end -->
    <!-- 第四步-弃用-start -->
    <div class="content" v-if="step == 4">
      <div class="box-input box-phone">
        <div>
          <div class="moblieWrap">
            <div class="origin-box">
              <img
                class="success_icon"
                src="../../assets/images/non_icon.png"
                alt=""
              />
              <div class="success-title">抱歉！课程手机号修改失败</div>
            </div>
          </div>
        </div>
      </div>
      <van-button class="loginBtn loginBtn-success" @click="changeFail"
        >联系客服</van-button
      >
    </div>
    <!-- 第四步-end -->
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'
import urls from '../../utils/urls'

export default {
  name: 'login',
  components: {},
  data() {
    return {
      step: 1,
      loginType: 0, //1 手机号 0 密码
      tel: '',
      mobile: '',
      newTel: '',
      verCode: '',
      newVerCode: '',
      password: '',
      isShowPassword: false,
      codeText: '获取验证码',
      isCount: false, //正在倒计时时不能点击
      codeTimer: '',
      loginLoading: false,
      loadingText: '正在修改',
      token: '',
      tokenKey: 'tokenKey',
      phoneKey: 'phoneKey',
      mainKeFuUrl:
        'https://work.weixin.qq.com/kfid/kfc7d5301c836e053ab?enc_scene=ENC3QTNZ7Rwc9EQ8M5WrnVEQqEKTCwzPjr5UJoegdoirVD3oEZqobbRv4h4uQM6aFF8aV'
    }
  },
  mounted() {
    document.title = '雪梨英语'
    this.token = localStorage.getItem(this.tokenKey)
    console.log('change', this.token)
    this.getUser()
    this.initShare()
  },
  watch: {},
  methods: {
    getCode() {
      let tempPhone = this.mobile
      if (this.step == 2) {
        tempPhone = this.newTel
        if (!this.newTel) {
          this.$toast('请输入手机号')
          return
        }
      }

      const params = { mobile: tempPhone, type: 'WX_BIND_MOBILE' }
      group.sendCode
        .call(this, params)
        .then((res) => {
          console.log('获取验证码', res)
          if (res.data.success) {
            this.$toast('验证码发送成功')
            // 开始倒计时
            this.isCount = true
            this.beginCount()
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 确认修改
    changeConfirm() {
      if (!this.newTel) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.newVerCode) {
        this.$toast('请输入验证码')
        return
      }

      console.log('开始修改')

      this.loginLoading = true
      const params = {
        mobile: this.newTel,
        verifyCode: this.newVerCode,
        token: this.token
      }
      group.mobileModify
        .call(this, params)
        .then((res) => {
          console.log('修改结果', res)
          this.loginLoading = false
          if (res.data.success) {
            this.$toast('修改成功')
            setTimeout(() => {
              this.step = 3
            }, 1000)
          } else {
            this.$toast(res.data.error.msg)
            // setTimeout(() => {
            //   this.step = 4
            // }, 1000)
          }
        })
        .catch((error) => {
          this.loginLoading = false
          console.log(error)
        })
    },
    // 倒计时
    beginCount() {
      let i = 60
      this.codeTimer = setInterval(() => {
        i--
        if (i <= 0) {
          clearInterval(this.codeTimer)
          this.codeText = '获取验证码'
          this.isCount = false
          return
        }
        this.codeText = i + 's后重新获取'
      }, 1000)
    },
    // 显示隐藏密码
    displayPassword(tag) {
      if (tag == 1) {
        this.isShowPassword = true
      } else {
        this.isShowPassword = false
      }
    },

    changeSuccess() {
      this.$router.replace({
        name: 'home'
      })
    },
    changeFail() {
      window.location.href = this.mainKeFuUrl
    },
    getUser() {
      const params = { token: this.token }
      group.userGet
        .call(this, params)
        .then((res) => {
          console.log('更改手机号用户信息', res)
          if (res.data.success) {
            this.mobile = res.data.data.mobile
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    nextstep(step) {
      console.log(step)
      if (!this.verCode) {
        this.$toast('请输入验证码')
        return
      }
      if (step == 1) {
        console.log('重置短信~~~')
        this.isCount = true
        this.step = 2
        // 清楚短信倒计时
        this.codeText = '获取验证码'
        this.isCount = false
        clearInterval(this.codeTimer)
      }
    },

    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style scoped></style>
